// extracted by mini-css-extract-plugin
export default {"card":"EditMindBaseExportPopup_card_NjPs5","column":"EditMindBaseExportPopup_column_pqf5c"};